import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { APP_BAR_HEIGHT } from './navbar/navbar.config';

export const MainContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  minHeight: '100vh',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    minHeight: `calc(100dvh - ${APP_BAR_HEIGHT})`,
    marginTop: APP_BAR_HEIGHT,
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(6, 3),
  [theme.breakpoints.up('md')]: {
    minHeight: '100vh',
    padding: theme.spacing(12, 14),
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(30),
  },
}));

export const PageContentWrapper = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));
